import { SELECT, TEXT, INPUT, NUMBER } from '..';

export const RESIDENCY_TITLE = 'Residency Info';

export const YEARS = 'Years';

export const YEAR_0_TEXT = '0 Years';
export const YEAR_1_TEXT = '1 Year';
export const YEAR_2_TEXT = '2 Years';
export const YEAR_3_TEXT = '3 Years';
export const YEAR_4_TEXT = '4 Years';
export const YEAR_5_TEXT = '5 Years';
export const YEAR_6_TEXT = '6 or More';

export const MONTHS = 'Months';

export const HIDDEN = 'hidden';

export const MONTH_0_TEXT = '0 Months';
export const MONTH_1_TEXT = '1 Month';
export const MONTH_2_TEXT = '2 Months';
export const MONTH_3_TEXT = '3 Months';
export const MONTH_4_TEXT = '4 Months';
export const MONTH_5_TEXT = '5 Months';
export const MONTH_6_TEXT = '6 Months';
export const MONTH_7_TEXT = '7 Months';
export const MONTH_8_TEXT = '8 Months';
export const MONTH_9_TEXT = '9 Months';
export const MONTH_10_TEXT = '10 Months';
export const MONTH_11_TEXT = '11 Months';

export const RESIDENCY_INFO = 'Residency Info';

export const STREET_ADDRESS = 'Street Address';
export const APT_UNIT = 'Apt / Unit (optional)';
export const CITY = 'City';
export const STATE = 'State';
export const ZIP_CODE = 'Zip Code';

export const LIVE_DURATION = 'How long have you lived here?';

export const OWN_RENT = 'Do you own or rent?';
export const TABS = 'Tabs';

export const OWN = 'Own';
export const own = 'own';
export const RENT = 'Rent';
export const rent = 'rent';
export const OTHER = 'Other';
export const other = 'other';

export const MONTHLY_PAYMENT = 'Monthly Payment';
export const RENT_PORTION_HELPER =
  'If you live with others, this should reflect the portion of housing costs that you personally pay.';

export const residencyInfoMapping = {
  city: 'City',
  state: 'State',
  aptUnit: 'Apt / Unit (optional)',
  streetAddress: 'Street Address',
  zipCode: 'Zip Code',
  monthlyPayment: 'Monthly Payment',
  tenantStatus: 'Do you own or rent?',
  'How long have you lived here?': { Years: 2, Months: 0 },
};

export const ALABAMA = 'Alabama';
export const AL = 'AL';

export const ALASKA = 'Alaska';
export const AK = 'AK';

export const ARIZONA = 'Arizona';
export const AZ = 'AZ';

export const ARKANSAS = 'Arkansas';
export const AR = 'AR';

export const CALIFORNIA = 'California';
export const CA = 'CA';

export const COLORADO = 'Colorado';
export const CO = 'CO';

export const CONNECTICUT = 'Connecticut';
export const CT = 'CT';

export const DELAWARE = 'Delaware';
export const DE = 'DE';

export const FLORIDA = 'Florida';
export const FL = 'FL';

export const GEORGIA = 'Georgia';
export const GA = 'GA';

export const HAWAII = 'Hawaii';
export const HI = 'HI';

export const IDAHO = 'Idaho';
export const ID = 'ID';

export const ILLINOIS = 'Illinois';
export const IL = 'IL';

export const INDIANA = 'Indiana';
export const IN = 'IN';

export const IOWA = 'Iowa';
export const IA = 'IA';

export const KANSAS = 'Kansas';
export const KS = 'KS';

export const KENTUCKY = 'Kentucky';
export const KY = 'KY';

export const LOUISIANA = 'Louisiana';
export const LA = 'LA';

export const MAINE = 'Maine';
export const ME = 'ME';

export const MARYLAND = 'Maryland';
export const MD = 'MD';

export const MASSACHUSETTS = 'Massachusetts';
export const MA = 'MA';

export const MICHIGAN = 'Michigan';
export const MI = 'MI';

export const MINNESOTA = 'Minnesota';
export const MN = 'MN';

export const MISSISSIPPI = 'Mississippi';
export const MS = 'MS';

export const MISSOURI = 'Missouri';
export const MO = 'MO';

export const MONTANA = 'Montana';
export const MT = 'MT';

export const NEBRASKA = 'Nebraska';
export const NE = 'NE';

export const NEVADA = 'Nevada';
export const NV = 'NV';

export const NEW_HAMPSHIRE = 'New Hampshire';
export const NH = 'NH';

export const NEW_JERSEY = 'New Jersey';
export const NJ = 'NJ';

export const NEW_MEXICO = 'New Mexico';
export const NM = 'NM';

export const NEW_YORK = 'New York';
export const NY = 'NY';

export const NORTH_CAROLINA = 'North Carolina';
export const NC = 'NC';

export const NORTH_DAKOTA = 'North Dakota';
export const ND = 'ND';

export const OHIO = 'Ohio';
export const OH = 'OH';

export const OKLAHOMA = 'Oklahoma';
export const OK = 'OK';

export const OREGON = 'Oregon';
export const OR = 'OR';

export const PENNSYLVANIA = 'Pennsylvania';
export const PA = 'PA';

export const RHODE_ISLAND = 'Rhode Island';
export const RI = 'RI';

export const SOUTH_CAROLINA = 'South Carolina';
export const SC = 'SC';

export const SOUTH_DAKOTA = 'South Dakota';
export const SD = 'SD';

export const TENNESSEE = 'Tennessee';
export const TN = 'TN';

export const TEXAS = 'Texas';
export const TX = 'TX';

export const UTAH = 'Utah';
export const UT = 'UT';

export const VERMONT = 'Vermont';
export const VT = 'VT';

export const VIRGINIA = 'Virginia';
export const VA = 'VA';

export const WASHINGTON = 'Washington';
export const WA = 'WA';

export const WEST_VIRGINIA = 'West Virginia';
export const WV = 'WV';

export const WISCONSIN = 'Wisconsin';
export const WI = 'WI';

export const WYOMING = 'Wyoming';
export const WY = 'WY';

export const RESIDENCY_STATE_OPTIONS = [
  { text: ALABAMA, value: AL },
  { text: ALASKA, value: AK },
  { text: ARIZONA, value: AZ },
  { text: ARKANSAS, value: AR },
  { text: CALIFORNIA, value: CA },
  { text: COLORADO, value: CO },
  { text: CONNECTICUT, value: CT },
  { text: DELAWARE, value: DE },
  { text: FLORIDA, value: FL },
  { text: GEORGIA, value: GA },
  { text: HAWAII, value: HI },
  { text: IDAHO, value: ID },
  { text: ILLINOIS, value: IL },
  { text: INDIANA, value: IN },
  { text: IOWA, value: IA },
  { text: KANSAS, value: KS },
  { text: KENTUCKY, value: KY },
  { text: LOUISIANA, value: LA },
  { text: MAINE, value: ME },
  { text: MARYLAND, value: MD },
  { text: MASSACHUSETTS, value: MA },
  { text: MICHIGAN, value: MI },
  { text: MINNESOTA, value: MN },
  { text: MISSISSIPPI, value: MS },
  { text: MISSOURI, value: MO },
  { text: MONTANA, value: MT },
  { text: NEBRASKA, value: NE },
  { text: NEVADA, value: NV },
  { text: NEW_HAMPSHIRE, value: NH },
  { text: NEW_JERSEY, value: NJ },
  { text: NEW_MEXICO, value: NM },
  { text: NEW_YORK, value: NY },
  { text: NORTH_CAROLINA, value: NC },
  { text: NORTH_DAKOTA, value: ND },
  { text: OHIO, value: OH },
  { text: OKLAHOMA, value: OK },
  { text: OREGON, value: OR },
  { text: PENNSYLVANIA, value: PA },
  { text: RHODE_ISLAND, value: RI },
  { text: SOUTH_CAROLINA, value: SC },
  { text: SOUTH_DAKOTA, value: SD },
  { text: TENNESSEE, value: TN },
  { text: TEXAS, value: TX },
  { text: UTAH, value: UT },
  { text: VERMONT, value: VT },
  { text: VIRGINIA, value: VA },
  { text: WASHINGTON, value: WA },
  { text: WEST_VIRGINIA, value: WV },
  { text: WISCONSIN, value: WI },
  { text: WYOMING, value: WY },
];

export const RESIDENCY_MODAL = {
  title: RESIDENCY_INFO,
  rows: [
    [
      {
        label: STREET_ADDRESS,
        fieldType: INPUT,
        onChange: () => {},
      },
    ],
    [
      {
        label: APT_UNIT,
        fieldType: INPUT,
        type: TEXT,
        fullWidthOnMobile: true,
        onChange: () => {},
      },
      {
        label: CITY,
        fieldType: INPUT,
        type: TEXT,
        fullWidthOnMobile: true,
        onChange: () => {},
      },
    ],
    [
      {
        label: STATE,
        fieldType: SELECT,
        options: RESIDENCY_STATE_OPTIONS,
        onChange: () => {},
      },
      {
        label: ZIP_CODE,
        fieldType: INPUT,
        type: NUMBER,
        onChange: () => {},
      },
    ],
    [
      {
        label: LIVE_DURATION,
        placeholder: YEARS,
        fieldType: SELECT,
        options: [
          { text: YEAR_0_TEXT, value: 0 },
          { text: YEAR_1_TEXT, value: 1 },
          { text: YEAR_2_TEXT, value: 2 },
          { text: YEAR_3_TEXT, value: 3 },
          { text: YEAR_4_TEXT, value: 4 },
          { text: YEAR_5_TEXT, value: 5 },
          { text: YEAR_6_TEXT, value: 6 },
        ],
        onChange: () => {},
      },
      {
        label: LIVE_DURATION,
        style: { visibility: HIDDEN },
        placeholder: MONTHS,
        fieldType: SELECT,
        options: [
          { text: MONTH_0_TEXT, value: 0 },
          { text: MONTH_1_TEXT, value: 1 },
          { text: MONTH_2_TEXT, value: 2 },
          { text: MONTH_3_TEXT, value: 3 },
          { text: MONTH_4_TEXT, value: 4 },
          { text: MONTH_5_TEXT, value: 5 },
          { text: MONTH_6_TEXT, value: 6 },
          { text: MONTH_7_TEXT, value: 7 },
          { text: MONTH_8_TEXT, value: 8 },
          { text: MONTH_9_TEXT, value: 9 },
          { text: MONTH_10_TEXT, value: 10 },
          { text: MONTH_11_TEXT, value: 11 },
        ],
      },
    ],
    [
      {
        label: OWN_RENT,
        fieldType: TABS,
        options: [
          { text: RENT, value: rent },
          { text: OWN, value: own },
          { text: OTHER, value: other },
        ],
        onChange: () => {},
      },
    ],
    [
      {
        label: MONTHLY_PAYMENT,
        fieldType: INPUT,
        placeholder: '$',
        type: NUMBER,
        helperText: RENT_PORTION_HELPER,
        onChange: () => {},
      },
    ],
  ],
};
